import React, { useEffect } from 'react';
import { RegionDomain } from '../../domains/region.domain';
import { di } from '../../state/inversify.config';
import { CurrentRegion } from '../../state/reduxRepositories/region/region.interface';
import { RegionChecking } from '../../helpers/regionChecking';
import { LoginForm } from './Login.form';

export const Login = () => {
  const regionDomain = di.get<RegionDomain>(RegionDomain);
  const currentRegion: CurrentRegion = regionDomain.useRegionSelector();
  const showDialog = regionDomain.useLoadDialogSelector();
  const isRegionMatch = regionDomain.useIsRegionMatching();

  useEffect(() => {
    regionDomain.dispatchRegion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentRegion?.country !== '' && !isRegionMatch) {
      regionDomain.dispatchDialog(true);
    }
    // eslint-disable-next-line prettier/prettier, react-hooks/exhaustive-deps
  }, [isRegionMatch, currentRegion]);

  return <>{showDialog ? <RegionChecking /> : <LoginForm />}</>;
};
